import { render } from "./Footer.vue?vue&type=template&id=0b461a9e&scoped=true"
import script from "@/wwwroot/js/footer.js?vue&type=script&lang=js"
export * from "@/wwwroot/js/footer.js?vue&type=script&lang=js"

import "@/wwwroot/css/footer.css?vue&type=style&index=0&id=0b461a9e&scoped=true&lang=css"
import "@/wwwroot/css/sharedStyles.css?vue&type=style&index=1&id=0b461a9e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b461a9e"]])

export default __exports__